// Copyright 2022 Google LLC. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file openapiv3/annotations.proto (package openapi.v3, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { Document, Operation, Schema } from "./OpenAPIv3_pb";
import { file_openapiv3_OpenAPIv3 } from "./OpenAPIv3_pb";
import type { FieldOptions, FileOptions, MessageOptions, MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file openapiv3/annotations.proto.
 */
export const file_openapiv3_annotations: GenFile = /*@__PURE__*/
  fileDesc("ChtvcGVuYXBpdjMvYW5ub3RhdGlvbnMucHJvdG8SCm9wZW5hcGkudjM6TwoIZG9jdW1lbnQSHC5nb29nbGUucHJvdG9idWYuRmlsZU9wdGlvbnMY9wggASgLMhQub3BlbmFwaS52My5Eb2N1bWVudFIIZG9jdW1lbnQ6VAoJb3BlcmF0aW9uEh4uZ29vZ2xlLnByb3RvYnVmLk1ldGhvZE9wdGlvbnMY9wggASgLMhUub3BlbmFwaS52My5PcGVyYXRpb25SCW9wZXJhdGlvbjpMCgZzY2hlbWESHy5nb29nbGUucHJvdG9idWYuTWVzc2FnZU9wdGlvbnMY9wggASgLMhIub3BlbmFwaS52My5TY2hlbWFSBnNjaGVtYTpOCghwcm9wZXJ0eRIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMY9wggASgLMhIub3BlbmFwaS52My5TY2hlbWFSCHByb3BlcnR5QloKDm9yZy5vcGVuYXBpX3YzQhBBbm5vdGF0aW9uc1Byb3RvUAFaLmdpdGh1Yi5jb20vZ29vZ2xlL2dub3N0aWMvb3BlbmFwaXYzO29wZW5hcGlfdjOiAgNPQVNiBnByb3RvMw", [file_openapiv3_OpenAPIv3, file_google_protobuf_descriptor]);

/**
 * @generated from extension: openapi.v3.Document document = 1143;
 */
export const document: GenExtension<FileOptions, Document> = /*@__PURE__*/
  extDesc(file_openapiv3_annotations, 0);

/**
 * @generated from extension: openapi.v3.Operation operation = 1143;
 */
export const operation: GenExtension<MethodOptions, Operation> = /*@__PURE__*/
  extDesc(file_openapiv3_annotations, 1);

/**
 * @generated from extension: openapi.v3.Schema schema = 1143;
 */
export const schema: GenExtension<MessageOptions, Schema> = /*@__PURE__*/
  extDesc(file_openapiv3_annotations, 2);

/**
 * @generated from extension: openapi.v3.Schema property = 1143;
 */
export const property: GenExtension<FieldOptions, Schema> = /*@__PURE__*/
  extDesc(file_openapiv3_annotations, 3);

